;
var myaNameSpace = myaNameSpace || {};
myaNameSpace.myaDisplayService = function () {

    const OptimizelyTestDisplay = function (variantConfig) {
        if (myaNotPresentOnPage()) {
            insertMyaOnPageAndBootMya(variantConfig);
        }
        else {
            bootMya(variantConfig);
        }
    }

    const myaNotPresentOnPage = function () {
        return (typeof (mya) == "undefined");
    }

    const insertMyaOnPageAndBootMya = function (variantConfig) {
        const script = document.createElement("script");
        script.type = "text/javascript";
        document.body.appendChild(script);
        script.onload = function () { bootMya(variantConfig); }
        script.src = "/mya/cse/widget.js";
    }

    const bootMya = function (variantConfig) {

        const environmentVariables = getCorrectEnvironmentVariables(variantConfig);
        const myaConfig = {
            "tenant": environmentVariables.myaEnv,
            "blueprint": environmentVariables.myaBlueprint,
            "start": getDisplayedOpenState(variantConfig.displayExpanded),
            "theme": "totaljobs",
            "newConversation": true,
            "tooltip": variantConfig.header,
            "themeOverwrite": {
                "header": {
                    "text": variantConfig.header
                }
            },
            "style": {
                "iconPositionY": "bottom"
            },
            "data": {
                "site_id": variantConfig.siteId,
                "conversation_group": variantConfig.variant,
                "job": {
                    "cta_send_application": variantConfig.ctaSendApplication,
                    "job_id": variantConfig.jobId
                }
            }
        };

        mya("boot", myaConfig);

    };

    const getCorrectEnvironmentVariables = function (variantConfig) {
        const environs = [
            { "regex": "totaljobs", "myaEnv": "mya", "myaBlueprint": variantConfig.productionBlueprint },
            { "regex": "tjgdev", "myaEnv": "myastaging", "myaBlueprint": variantConfig.devBlueprint },
            { "regex": "tjgpat", "myaEnv": "mya", "myaBlueprint": variantConfig.patBlueprint }
        ]
        return environs.reduce(function (previousEnviron, environ) { return (window.location.host.includes(environ.regex)) ? environ : previousEnviron });
    }

    const getDisplayedOpenState = function (isOpenedExpanded) {
        return isOpenedExpanded
            ? "expanded"
            : "minimized";
    }

    return {
        OptimizelyTestDisplay: OptimizelyTestDisplay
    };

}();

